export const StoreDownloadSection = {
  STORE_DOWNLOAD_SECTION_HEAD: '시청하지 말고 플레이 해!\n실시간 참여형 콘텐츠, ',
  STORE_DOWNLOAD_SECTION_HEAD_MOBILE: '시청하지 말고 플레이 해!\n실시간 참여형 콘텐츠',
  STORE_DOWNLOAD_SECTION_BODY:
    '지루한 영상 시청은 이제 그만!\n나의 목소리, 감정, 제스쳐에 콘텐츠가 반응해요!\n지금, ZUICY에서 나만의 이야기를 플레이해보세요.',
};
